
<div v-if="content.listeIdProduit" :class="jel_getClassObject(content)" class="w-100">
  <CarteListe :content="getContentCarteListe()">
    <template #element="{ itemElement, elementPremiereLigne }">
      <MediaImageLogoProduitCasinoLarge
        v-if="content.nbColonne == 1"
        :content="{
          ...getItemElement(itemElement),
          isListeHorizontale: content.isListeHorizontale,
          formatCarte: content.formatCarte,
        }"
        class="h-100 d-flex align-items-center"
      >
      </MediaImageLogoProduitCasinoLarge>
      <MediaImageLogoProduitCasino3x4
        v-else-if="content.nbColonne == 2"
        :content="{
          ...getItemElement(itemElement),
          nbColonne: content.nbColonne,
          elementPremiereLigne: elementPremiereLigne,
        }"
      >
      </MediaImageLogoProduitCasino3x4>
    </template>
  </CarteListe>
</div>
